import React from "react"

import { ViewsContext } from "~/Views/ViewsProvider"

export const useViews = () => {
  const context = React.useContext(ViewsContext)
  return context
}
